import { Button, Card } from "antd";
import Rate from "./rate";
import Buttonn from "../common/button";
import { useState } from "react";
import colors from "../../share/constants/constants";
import profileAvatar from "./../../assets/icons/profilepic.png";

const ReviewsCard = ({
  customer,
  customerImg,
  review,
  date,
  rating,
  msg,
  bgColor,
  reviewsLength,
  textColor,
  openModal,
  onReplyButtonClick,
  id,
}) => {
  const [click, setClick] = useState(false);
  const replyButton = () => {
    onReplyButtonClick(id);
    setClick(!click);
  };
  return (
    <Card className={`mx-2.5 mt-0.4 bg-${bgColor} ${textColor} `}>
      <div className="sm:grid sm:grid-cols-5 sm:justify-between sm:gap-2 grid grid-cols-2 mx-2.5 my-1">
        <div>
          <p
            className={
              textColor
                ? "text-white font-medium"
                : `text-primaryPurple font-medium`
            }
          >
            Customer
          </p>
          <div className="flex items-center">
            <img
              src={customerImg ?? profileAvatar}
              alt="customer"
              className="rounded-full w-3 h-3"
            />
            <span className="ml-1 font-medium">{customer}</span>
          </div>
        </div>
        <div className="">
          <p
            className={
              textColor
                ? "text-white font-medium"
                : `text-primaryPurple font-medium`
            }
          >
            Review
          </p>
          <span className="font-medium">{review}</span>
        </div>
        <div>
          <p
            className={
              textColor
                ? "text-white font-medium"
                : `text-primaryPurple font-medium`
            }
          >
            Date
          </p>
          <span className="font-medium">{date}</span>
        </div>
        <div>
          <p
            className={
              textColor
                ? "text-white font-medium"
                : `text-primaryPurple font-medium`
            }
          >
            Rating
          </p>
          <Rate value={rating} disabled={"disabled"} />
        </div>
        <div className="sm:grid sm:items-center sm:justify-end">
          <Button
            className="border-none p-0"
            style={{ backgroundColor: "transparent" }}
            onClick={() => openModal(id)}
          >
            {msg && (
              <img src={msg} alt="message-icon" onClick={() => openModal(id)} />
            )}
          </Button>
          {reviewsLength < 2 && (
            <Buttonn
              title={`${click ? "Cancel" : "Reply"}`}
              className="w-10 !h-4"
              color={colors.primaryBlue}
              onClick={replyButton}
            />
          )}
        </div>
      </div>
    </Card>
  );
};
export default ReviewsCard;
